module.exports = __webpack_public_path__ + "img/Icon_Tag_Pro_Gold.e9d94e59.svg";